import { Boarding } from "features/schedule/boarding";
import { Route } from "react-router-dom";

export const BoardingRoutes = (
  <Route path="boarding" element={<Boarding />}></Route>
);
